import { decode } from 'he'

export function decodehtml(encodedHtml = '') {
  if (!encodedHtml) return ''
  return decode(encodedHtml)
}
